import {validationMixin} from 'vuelidate';
import AppInput from "./Input";
import AppSwitch from "./Switch";
import AppTextarea from "./Textarea";
import AppCheckbox from "./Checkbox";
import AppYesNoSwitch from "./YesNoSwitch";
import AppRadioSelect from "./RadioSelect";


export default {
    mixins: [validationMixin],
    components: {
        AppInput,
        AppSwitch,
        AppTextarea,
        AppCheckbox,
        AppYesNoSwitch,
        AppRadioSelect
    },
    methods: {},
}




// WEBPACK FOOTER //
// ./src/public_app/elements/FormBase.js